import {AbsentVisibilityView} from "module/selpan/impl/person/view/AbsentVisibilityView";
import {SelPanMenuView} from "module/selpan/menu/SelPanMenuView";
import {SelPanModelView} from "module/selpan/SelPanModelView";
import {SelPanView} from "module/selpan/SelPanView";
import {invokeLastFunc} from 'util/FuncUtil';
import {templateModel} from 'module/selpan/impl/person/model/PersonUtil';
import {getPersonInfoRepresentation, wrapTemplateWithSelPanTemplate} from 'model/Person';

export const PersonModelView = SelPanModelView.extend({
	initialize: function () {
		this.delayed = invokeLastFunc(this, ['render'], 40);
		this.listenTo(templateModel, "change", this.refreshTemplate);
		this.refreshTemplate();
		SelPanModelView.prototype.initialize.apply(this, arguments);
	},
	refreshTemplate: function () {
		this.template = getPersonInfoRepresentation(wrapTemplateWithSelPanTemplate(templateModel.get('templateIndex')), 'm');
		this.delayed.render();
	},
	getTemplateData: function () {
		let m = this.model;
		return {
			m: {
				id: m.id,
				...m.attributes,
				visibleClass: m.get("visible") ? this.selectedClass : this.deselectedClass,
				myselfClass: m.get("myself") ? "fa fa-user" : "",
				disabledClass: m.get('_disabled') ? this.disabledClass : undefined,
			},
		};
	},
});

export const PersonSelPanMenuView = SelPanMenuView.extend({
	extViewClasses: {
		others: [AbsentVisibilityView],
	},
});

export const PersonSelPanView = SelPanView.extend({
	ModelView: PersonModelView,
	MenuView: PersonSelPanMenuView,
});